import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import HomePage from './components/HomePage';
import reportWebVitals from './reportWebVitals';
import { StatsigProvider } from '@statsig/react-bindings';
import { v4 as uuidv4 } from 'uuid';

// Statsig client key
const STATSIG_CLIENT_KEY = 'client-zefHejQfuAy8VnP22dqleSnHE5HoWubOq8BfEwpzMw6';

// Determine environment tier based on NODE_ENV
// In development (local): Use 'development'
// In production (deployed): Use 'production'
const isLocalDevelopment = process.env.NODE_ENV === 'development';
const statsigEnvironmentTier = isLocalDevelopment ? 'development' : 'production';

// Log the current environment for debugging
console.log(`Running in ${process.env.NODE_ENV} mode with Statsig tier: ${statsigEnvironmentTier}`);

// Generate or retrieve a persistent user ID for Statsig
const getUserId = () => {
  // Check if we already have a stored user ID
  const storedUserId = localStorage.getItem('toonhouse_user_id');
  
  if (storedUserId) {
    console.log('Using existing user ID for Statsig');
    return storedUserId;
  }
  
  // For development, we can use a fixed ID to make testing easier
  if (isLocalDevelopment && process.env.REACT_APP_USE_FIXED_USER_ID === 'true') {
    const devUserId = 'dev-test-user-id';
    localStorage.setItem('toonhouse_user_id', devUserId);
    console.log('Using fixed development user ID for Statsig');
    return devUserId;
  }
  
  // Generate a new UUID for this user
  const newUserId = uuidv4();
  localStorage.setItem('toonhouse_user_id', newUserId);
  console.log('Generated new user ID for Statsig');
  return newUserId;
};

const userId = getUserId();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatsigProvider 
      sdkKey={STATSIG_CLIENT_KEY}
      user={{ 
        userID: userId,
        // You can add additional user properties here if needed
        // For example:
        // email: userEmail,
        // country: userCountry,
        custom: {
          isLocalDevelopment
        }
      }}
      waitForInitialization={false}
      options={{ 
        environment: { tier: statsigEnvironmentTier },
        // Enable auto-capture of basic events
        enableAutoCapture: true
      }}
      onInitialized={() => console.log('Statsig initialized successfully!')}
      onError={(error) => console.error('Statsig initialization error:', error)}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vote" element={<App />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </StatsigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
